import React from "react";
import {
  QueryClient,
  QueryCache,
  MutationCache,
  QueryClientProvider as RQProvider,
} from "@tanstack/react-query";
import {
  isMidwaySessionUnavailable,
  markMidwaySessionReloadPending,
} from "@/common/helpers/midway-session-error.helper";

export const handleQueryError = (error: unknown): void => {
  if (isMidwaySessionUnavailable(error)) {
    markMidwaySessionReloadPending();
    window.location.reload();
    return;
  }

  console.error("Query/mutation error:", error);
};

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: handleQueryError }),
  mutationCache: new MutationCache({ onError: handleQueryError }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: (failureCount: number) => failureCount < 1,
      refetchOnWindowFocus: false,
    },
  },
});

export const QueryClientProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <RQProvider client={queryClient}>{children}</RQProvider>
);
